import React, { useState } from "react";
import "tw-elements";
import Carousel from "react-simply-carousel";

const Card = ({ title, img }) => {
  return (
    <div className="mx-2 flex flex-col gap-2 text-xs w-56">
      <img
        src={process.env.PUBLIC_URL + img}
        alt="Covid"
        className="h-36 object-cover"
      />
      <div className="text-primary font-bold text-2xl">{title}</div>
      <div className="text-md">
        To Assist Recipients related to Covid-19 category that may have
        shortfalls or immediate needs.
      </div>
      <div className="h-1 bg-primary"></div>
      <div className="text-md">
        <span className="text-primary">$0.00</span> Raised from{" "}
        <span>$2,400.00</span>
      </div>
    </div>
  );
};

const CampaignCard = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const cardData = [
    {
      img: "assets/images/worker.png",
      title: "COVID-19",
      context:
        "To Assist Recipients related to Covid-19 category that may have shortfalls or immediate needs.",
    },
    {
      img: "assets/images/worker.png",
      title: "Animal",
      context:
        "To Assist Recipients related to Covid-19 category that may have shortfalls or immediate needs.",
    },
    {
      img: "assets/images/worker.png",
      title: "Youth",
      context:
        "To Assist Recipients related to Covid-19 category that may have shortfalls or immediate needs.",
    },
    {
      img: "assets/images/worker.png",
      title: "Senior Care",
      context:
        "To Assist Recipients related to Covid-19 category that may have shortfalls or immediate needs.",
    },
    {
      img: "assets/images/worker.png",
      title: "Minority Diversity",
      context:
        "To Assist Recipients related to Covid-19 category that may have shortfalls or immediate needs.",
    },
  ];
  return (
    <div className="container mx-auto my-10">
      <Carousel
        containerProps={{
          style: {
            width: "100%",
            justifyContent: "space-evenly",
          },
        }}
        activeSlideIndex={activeSlide}
        onRequestChange={setActiveSlide}
        forwardBtnProps={{
          children: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-full p-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="blue"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          ),
          style: {
            borderRadius: 100,
            width: 40,
            height: 40,
            alignSelf: "center",
            background:
              "linear-gradient(90deg, rgba(255,181,212,1) 33%, rgba(255,252,192,1) 64%, rgba(255,143,190,1) 100%)",
          },
        }}
        backwardBtnProps={{
          children: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-full p-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="blue"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          ),
          style: {
            borderRadius: 100,
            width: 40,
            height: 40,
            alignSelf: "center",
            background:
              "linear-gradient(90deg, rgba(255,181,212,1) 33%, rgba(255,252,192,1) 64%, rgba(255,143,190,1) 100%)",
          },
        }}
        itemsToShow={1}
        speed={400}
        responsiveProps={[
          {
            itemsToShow: 2,
            minWidth: 600,
          },
          {
            itemsToShow: 4,
            minWidth: 1023,
          },
        ]}
      >
        {cardData.map((item, index) => (
          <Card img={item.img} title={item.title} key={index} />
        ))}
      </Carousel>
    </div>
  );
};

export default CampaignCard;
